import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {ServiceRequestStatus, userType} from '../../util/uiconstants';

export default function serviceRequestsReducer(state = initialstate.serviceRequests, action) {
	switch (action.type) {
		case types.RESET_TASK_ATTRIBUTES:
			return initialstate.serviceRequests;
		default:
			return state;
	}
}
